export default [
  {
    id: `material`,
    title: `Описание`,
    content: {
      description: `
        <p>
          Форма - прямоугольник.<br>
          Размер - 15х4.5 см.<br>
          Материал - магнитная основа.<br>
          Количество - 5 магнитов на лист А4.
        </p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `
        <p>
          Изображение наносится на магнитную основу. Сверху на изображение наносится специальное полимерное покрытие - «смола». Создаётся прозрачный и мягкий «купол». На завершающем этапе заготовки подвергаются термической обработке. В специальной камере смола затвердевает, а магнит приобретает необходимый блеск.
        </p>
      `
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
